import { useState } from 'react';
import { useLazyUserConsentsQuery } from '../../../graphql/graphql';

export default function useInformedConsents() {
	const [getUserConsentsQuery, { data, isLoading }] =
		useLazyUserConsentsQuery();
	const [page, setPage] = useState(1);

	const getFlatInformedConsents = (filter: object) => {
		getUserConsentsQuery({
			where: filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatInformedConsents,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
